import { FormattedMessage } from "react-intl";
import ActiveIndicator from "../../../Shared/ActiveIndicator/ActiveIndicator";
import NoDataIndicator from "../../../Shared/NoDataIndicator/NoDataIndicator";
import PatientsIcon from "../../../Shared/PatientsIcon/PatientsIcon";
import UserIcon from "../../../Shared/UserIcon/UserIcon";
import PendingUserIcon from "../../PendingUserIcon/PendingUserIcon";

type UsersCountProps = {
  total?: number;
  active?: number;
  pending?: number;
  inactive?: number;
  extended?: boolean;
  showPending?: boolean;
  isPatientsCount?: boolean;
};

const UsersCount = ({
  total,
  active,
  pending,
  inactive,
  extended,
  showPending = false,
  isPatientsCount = false,
}: UsersCountProps) => {
  return (
    <div className={`d-flex align-items-center`}>
      <div className="d-flex align-items-center">
        {!isPatientsCount ? <UserIcon /> : <PatientsIcon />}
        {extended && (
          <>
            &nbsp;
            <strong>
              <FormattedMessage id="MANAGEMENT.USERS" defaultMessage="Users" />:
            </strong>
            &nbsp;
            <span>
              <FormattedMessage id="GLOBAL.TOTAL" defaultMessage="Total" />
            </span>
          </>
        )}
        &nbsp;{total ?? <NoDataIndicator />}
      </div>
      <div className="mx-2"></div>
      {showPending && (
        <>
          <div className="d-flex align-items-center">
            <PendingUserIcon />
            {extended && (
              <>
                &nbsp;
                <FormattedMessage
                  id="MANAGEMENT.PENDING"
                  defaultMessage="Pending"
                />
              </>
            )}
            &nbsp;{pending ?? <NoDataIndicator />}
          </div>
          <div className="mx-2"></div>
        </>
      )}
      <div className="d-flex align-items-center">
        <ActiveIndicator active />
        {extended && (
          <>
            &nbsp;
            <FormattedMessage id="MANAGEMENT.ACTIVE" defaultMessage="Active" />
          </>
        )}
        &nbsp;{active ?? <NoDataIndicator />}
      </div>
      <div className="mx-2"></div>
      <div className="d-flex align-items-center">
        <ActiveIndicator />
        {extended && (
          <>
            &nbsp;
            <FormattedMessage
              id="MANAGEMENT.DEACTIVATED"
              defaultMessage="Deactivated"
            />
          </>
        )}
        &nbsp;{inactive ?? <NoDataIndicator />}
      </div>
    </div>
  );
};

export default UsersCount;
